import React from 'react';
import { Campaign, Client } from '@foodfluence/shared';
import { CollabTask, showSpotsBadge } from '../../utils/collabUtils';
import { HomeRow, RowArrow, RowAvatar, RowPill, isUgcCollab } from './CollabCard';
import { formatTimeLeft } from '../../utils/dateUtils';

interface TaskCardProps {
  task: CollabTask;
  campaign: Campaign;
  client: Client | undefined;
  remainingSpots?: number | null;
  onClick: () => void;
}

const TaskCard: React.FC<TaskCardProps> = ({ task, campaign, client, remainingSpots, onClick }) => {
  const showSpots = showSpotsBadge(task.collab, campaign, remainingSpots);
  const isDueSoon = task.dueDate != null && task.dueDate.getTime() <= Date.now() + 3 * 24 * 60 * 60 * 1000;
  let futureLabel: string | undefined = undefined
  let pastLabel: string | undefined = undefined

  if (task.title == "Visit Store & Redeem Now!") {
    futureLabel = "Left to Visit Store"
    pastLabel = "Left to Visit Store"
  }
  else if (task.title == 'Prepare to Visit Store') {
    futureLabel = "Until Visit"
  }
  else if (task.title == "View Reward") {
    futureLabel = 'Left to Use Reward'
    pastLabel = 'Left to Use Reward'
  }
  else if (task.title == 'Schedule Store Visit' || task.title == 'Schedule Posting Date' || task.title == 'Schedule Delivery Date' || task.title == 'Add Shipping Address') {
    futureLabel = 'Until Campaign Ends'
  pastLabel = 'Campaign Ended'
  }

  const timeLeftFormatted = formatTimeLeft(task.dueDate ?? null, futureLabel, pastLabel);

  const clientName = client?.accountName ?? 'Unknown Brand';

  return (
    <HomeRow
      onClick={onClick}
      avatar={<RowAvatar name={clientName} src={campaign?.collabImage || client?.bannerPicture || client?.instagramProfilePicture} />}
      primary={task.title}
      ugc={isUgcCollab(task.collab, campaign)}
      secondary={clientName}
      meta={timeLeftFormatted || undefined}
      urgent={isDueSoon}
      right={
        showSpots && remainingSpots != null ? (
          <RowPill tone="limited">
            {remainingSpots} Spot{remainingSpots !== 1 ? 's' : ''} Remaining
          </RowPill>
        ) : (
          <RowArrow />
        )
      }
    />
  );
};

export default TaskCard;
